import { PbxHttpClient } from "@/services/httpclient";

const state = {
  allCategories: [],
};

const getters = {
  GET_ALL_CATEGORIES(state) {
    return state.allCategories;
  },
  GET_CATEGORY: (state) => (id) => {
    return state.allCategories.find((cat) => cat.id === id);
  },
};

const mutations = {
  SET_ALL_CATEGORIES: (state, payload) => (state.allCategories = payload),

  SET_CATEGORIES: (state, payload) =>
    (state.allCategories = state.allCategories.concat(payload)),

  PUSH_CATEGORY: (state, payload) =>
    (state.allCategories = [...state.allCategories, payload]),

  UPDATE_CATEGORY: (state, payload) =>
    (state.allCategories = state.allCategories.map((el) =>
      el.id === payload.id ? payload : el
    )),
  DELETE_CATEGORY: (state, id) =>
    (state.allEvaluations = state.allCategories.filter((el) => el.id !== id)),

  PUSH_QUESTION: (state, payload) => {
    state.allCategories = state.allCategories.map((el) =>
      el.id === payload.category_id
        ? {
            ...el,
            questions: [...el.questions, payload],
          }
        : el
    );
    // const category = state.allCategories.find(
    //     c => c.id === payload.category_id
    // );
    // if (category) category.questions.push(payload);
  },
};

const actions = {
  async REGISTER_CATEGORY({ state, commit }, payload) {
    try {
      const response = await PbxHttpClient.post("/quality/category", payload);
      //FOR TESTING
      //console.log(response.data.category)
      commit("PUSH_CATEGORY", response.data.category);
      return;
    } catch (error) {
      return error.message.includes("422") ? 422 : error;
    }
  },

  async SHOW_CATEGORIES({ commit, state }, payload) {
    try {
      // if (!page) {
      //     const response = await PbxHttpClient.get("/quality/category");
      //     commit("SET_ALL_CATEGORIES", response.data.data);
      //     return response.data;
      // } else {
      const response = await PbxHttpClient.get(
        `/quality/category?page=${payload.page || 1}&itemPerPage=${payload.itemsPerPage}`
      );
      //Compare if response items already exists in store
      const categoriesStr = JSON.stringify(state.allCategories);
      const resStr = JSON.stringify(response.data.data);
      if (!categoriesStr.includes(resStr.substring(1, resStr.length - 1)))
        commit("SET_CATEGORIES", response.data.data);
      return response.data;
      // }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async GET_ALL_CATEGORIES({ commit }) {
    try {
      let page = 1;
      let categoriesList = [];
      let isLoop = true;
      do {
        const { data } = await PbxHttpClient.get(`/quality/category`, {
          params: {
            page,
            itemsPerPage: 50,
          },
        });
        categoriesList = [...categoriesList, ...data.data];
        if (data.last_page > page) page += 1;
        else isLoop = false;
      } while (isLoop);
      commit("SET_ALL_CATEGORIES", categoriesList);
      return categoriesList;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async EDIT_CATEGORY({ commit }, payload) {
    try {
      console.log(payload);
      const categoryEdited = {
        title: payload.title,
        description: payload.description,
      };
      const response = await PbxHttpClient.put(
        `/quality/category/${payload.id}`,
        categoryEdited
      );
      // console.log(response.data)
      commit("UPDATE_CATEGORY", response.data.category);
    } catch (error) {
      return error.message.includes("422") ? 422 : error;
    }
  },

  async DELETE_CATEGORY({ commit }, id) {
    try {
      const res = await PbxHttpClient.delete(`/quality/category/${id}`);
      commit("DELETE_CATEGORY", id);
      return;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  REGISTER_QUESTION_TO_CATEGORY({ commit }, payload) {
    commit("PUSH_QUESTION", payload);
  },
};

// Exportar Clientes
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
